export const AccessTokenKey = 'access_token'
export const RootGroupIdKey = 'root_group_id'

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift()
    return cookieValue !== undefined ? cookieValue : null
  }
  return null
}

const deleteCookie = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.mamorio.jp`
}

export const getAccessToken = (): string | null => {
  const cookieAccessToken = getCookie(AccessTokenKey)
  if (cookieAccessToken) {
    deleteCookie(AccessTokenKey)
    localStorage.setItem(AccessTokenKey, cookieAccessToken)
    return cookieAccessToken
  }

  return localStorage.getItem(AccessTokenKey)
}

export const getRootGroupId = (): GroupId => {
  const cookieRootGroupId = getCookie(RootGroupIdKey)
  if (cookieRootGroupId) {
    deleteCookie(RootGroupIdKey)
    localStorage.setItem(RootGroupIdKey, cookieRootGroupId)
    return Number(cookieRootGroupId) as GroupId
  }

  const rootGroupId = localStorage.getItem(RootGroupIdKey)
  if (!rootGroupId) return NaN as GroupId

  return Number(rootGroupId) as GroupId
}

// 大阪ガス対応。後ほど削除
export const showLostAndBattery = (): boolean => {
  const groupId = getRootGroupId()
  let showLostAndBatteryGroups = []
  if (process.env.REACT_APP_BASE_PATH === 'https://user.mamorio.jp') {
    showLostAndBatteryGroups = [227, 1136, 1232]
  } else {
    showLostAndBatteryGroups = [65]
  }
  if (groupId && showLostAndBatteryGroups.includes(groupId)) {
    return true
  }
  return false
}

export const showMapOnListTop = (): boolean => {
  const hostname = process.env.REACT_APP_HOSTNAME || window.location.hostname
  const teamDomain = hostname?.split('.')[0]
  if (teamDomain === 'grapestone_biz') {
    return true
  }

  const groupId = getRootGroupId()
  let groups = []
  if (process.env.REACT_APP_BASE_PATH === 'https://user.mamorio.jp') {
    groups = [227, 1294]
  } else {
    groups = [65]
  }
  if (groupId && groups.includes(groupId)) {
    return true
  }
  return false
}

export const removeSession = () => {
  localStorage.removeItem(AccessTokenKey)
  localStorage.removeItem(RootGroupIdKey)
  deleteCookie(AccessTokenKey)
  deleteCookie(RootGroupIdKey)
}

export const saveSession = (accessToken: string, rootGroupId: string) => {
  localStorage.setItem(AccessTokenKey, accessToken)
  localStorage.setItem(RootGroupIdKey, rootGroupId)
}

export const appendAuthToken = (path: string): string => {
  const token = getAccessToken()
  if (!token) return path

  const hasQuery = path.includes('?')
  const separator = hasQuery ? '&' : '?'
  return `${path}${separator}auth_token=${encodeURIComponent(token)}`
}
